import { render, staticRenderFns } from "./NewRoute.vue?vue&type=template&id=5cd89aa8&scoped=true&"
import script from "./NewRoute.vue?vue&type=script&lang=js&"
export * from "./NewRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd89aa8",
  null
  
)

export default component.exports